import APIconsume from './../APIconsume'
import LoginService from "../LoginService"

class FupQuotaService extends LoginService {
    constructor() {
        super()
        this._url = '/fup/quota'
        this._consume = new APIconsume()
    }

    async getOptions () {
        const result = await this._consume.getData(`${this._url}/options`)
        return result.data
    }

    async getPurchases () {
        const result = await this._consume.getData(`${this._url}/purchases`)
        return result.data
    }

    async getState () {
        const result = await this._consume.getData(`${this._url}/pending`)
        return result.data
    }

    async getPurchase (id) {
        const result = await this._consume.getData(`${this._url}/purchases/${id}`)
        return result.data
    }

    async createPurchase (payload) {
        const result = await this._consume.postData(payload, `${this._url}/purchases`)
        return result.data
    }
}

export default FupQuotaService
